import React, { useState } from 'react';
import PublicIcon from '@material-ui/icons/Public';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
} from 'candy-commons-components';
import {
    BooleanInput,
    Edit,
    required,
    SaveButton,
    SimpleForm,
    TextInput,
    Toolbar,
    useTranslate,
    useDelete,
    useNotify,
    useRedirect,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DeleteIcon from '@material-ui/icons/Delete';

const useToolbarStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
});

const DeleteWithConfirmButton = ({ record, resource }) => {
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const redirect = useRedirect();
    const [deleteOne, { loading }] = useDelete(
        resource,
        record && record.id,
        record,
        {
            onSuccess: () => {
                notify('Configuration deleted', 'info');
                redirect('list', `/${resource}`);
            },
            onFailure: (error) => {
                notify(`Error: ${error.message}`, 'warning');
            },
        }
    );

    return (
        <>
            <Button
                variant="contained"
                color="secondary"
                startIcon={<DeleteIcon />}
                onClick={() => setOpen(true)}
                style={{ marginLeft: '8px' }}
            >
                Delete
            </Button>
            <Dialog open={open} onClose={() => setOpen(false)}>
                <DialogTitle>Delete configuration</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the configuration for{' '}
                        <strong>
                            {record && record.brand}/{record && record.country}
                        </strong>
                        ? This action cannot be undone.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => setOpen(false)}
                        color="primary"
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={deleteOne}
                        color="secondary"
                        disabled={loading}
                        autoFocus
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

const EcommerceCountryConfigToolbar = ({
    permissions,
    resource,
    record,
    ...props
}) => (
    <Toolbar {...props} classes={useToolbarStyles()}>
        <SaveButton />
        <span style={{ flex: '1' }} />
        {permissions &&
            permissions[resource] &&
            permissions[resource].delete && (
                <DeleteWithConfirmButton record={record} resource={resource} />
            )}
    </Toolbar>
);

const EcommerceCountryConfigEdit = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation(
                'resources.ecommerce-country-config.name',
                'Ecommerce Country Configuration'
            ),
            url: 'ecommerce-country-config',
            icon: <PublicIcon />,
        },
        {
            text: translation(
                'resources.ecommerce-country-config.edit.name',
                'Edit'
            ),
            url: '',
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit {...props}>
                <SimpleForm
                    toolbar={
                        <EcommerceCountryConfigToolbar
                            permissions={permissions}
                            resource={props.resource}
                        />
                    }
                >
                    <ContainerFieldsList>
                        <TextInput
                            source="brand"
                            label="Brand"
                            disabled
                            validate={[required()]}
                        />
                        <TextInput
                            source="country"
                            label="Country Code"
                            disabled
                            validate={[required()]}
                        />
                        <BooleanInput source="enabled" label="Enabled" />
                    </ContainerFieldsList>
                </SimpleForm>
            </Edit>
        </>
    );
};

export default EcommerceCountryConfigEdit;
